(function(){
  // Verified alias groups - each maps recognized input tokens to extra OR terms
  // that carry REAL, catalog-confirmed coverage (see PHASE_10_ENGLISH_NORMALIZATION_MAP.csv,
  // PHASE_10_ARABIC_NORMALIZATION_MAP.csv, and this phase's _evidence/ARABIC_ALIAS_EVIDENCE.md).
  // Ambiguous/zero-coverage groups (jacket, dress, pants, perfume, sale, wallet, generic colour)
  // are intentionally NOT included - Phase 10 confirmed 0 or ambiguous catalog coverage for
  // them and they remain flagged for owner review rather than fabricated here.
  //
  // Multi-word terms (containing a space) are wrapped in double quotes before being sent to
  // Shopify, e.g. "تي شيرت" OR shirt. Without quoting, Shopify's search query parser treats the
  // internal space as an implicit term separator (effectively تي AND (شيرت OR shirt)), which
  // silently breaks the alias for any two-word input even though the single-word alias works
  // (confirmed: unquoted "تي شيرت OR shirt" = 0 results; quoted = 39, matching تيشيرت). This was
  // found and fixed in this phase; hyphenated forms (تي-شيرت) were unaffected and did not need
  // quoting, but are quoted too for consistency/future-proofing since it is a safe no-op for them.
  //
  // The hamza-bearing-term OR-query issue Phase 10 documented (إكسسوار/إكسسوارات) was re-tested
  // in this phase WITH quoting applied and no longer reproduces (3 stable repeated queries, see
  // _evidence/ARABIC_ALIAS_EVIDENCE.md) - quoting appears to protect hamza characters from the
  // same parser issue that affected unquoted multi-word terms, so those forms are re-activated.
  var GROUPS = [
    { match: ['women','woman','womens',"women's",'ladies','نساء','نسائي','نسائية','سيدات'], addTerms: ['حريمي'] },
    { match: ['men','man','mens',"men's",'رجال'], addTerms: ['رجالي'] },
    { match: ['tshirt','t-shirt','t shirt','tee','تيشيرت','تشيرت','تي شيرت','تي-شيرت'], addTerms: ['shirt'] },
    { match: ['handbag','bag','حقيبة','حقائب','شنطة','شنط'], addTerms: ['bag'] },
    // Accessories: real but thin coverage (2 English matches at time of testing). Included
    // because it is genuine catalog evidence, not fabricated - see evidence doc for the exact
    // measured counts and the note on result-count variability observed during testing.
    { match: ['accessories','اكسسوارات','إكسسوارات','اكسسوار','إكسسوار'], addTerms: ['accessories'] },
    // كوتشي (colloquial Egyptian Arabic for sneakers/trainers) - "OR sneakers" returned 0
    // (platform quirk on that specific English token in an OR clause); "OR SHOES" returned 28
    // and is the broader, still-accurate category, so SHOES is used instead.
    { match: ['كوتشي'], addTerms: ['SHOES'] },
    // Brand transliterations - only for vendors confirmed present in the live catalog.
    { match: ['جوتشي','غوتشي'], addTerms: ['GUCCI'] },
    { match: ['هيرميس','هيرمس'], addTerms: ['HERMES'] },
    { match: ['ديور'], addTerms: ['DIOR'] },
    { match: ['برادا'], addTerms: ['PRADA'] },
    { match: ['شانيل'], addTerms: ['CHANEL'] }
  ];

  function normalizeToken(t){
    return (t||'').trim().toLowerCase();
  }

  function quoteIfMultiWord(t){
    return /\s/.test(t) ? '"' + t + '"' : t;
  }

  // Returns { expanded: <query string to send to Shopify>, changed: bool }
  function expandQuery(raw){
    var term = (raw || '').trim();
    if (!term) return { expanded: term, changed: false };
    var lower = normalizeToken(term);
    var extra = [];
    GROUPS.forEach(function(g){
      if (g.match.indexOf(lower) !== -1) {
        g.addTerms.forEach(function(t){ if (extra.indexOf(t) === -1) extra.push(t); });
      }
    });
    if (!extra.length) return { expanded: term, changed: false };
    var parts = [quoteIfMultiWord(term)].concat(extra.map(quoteIfMultiWord));
    return { expanded: parts.join(' OR '), changed: true };
  }

  window.VantoSearchNormalize = { expandQuery: expandQuery };
})();
